var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module windy
 */
import ViewHint from 'ol/ViewHint.js';
import WebGLArrayBuffer from 'ol/webgl/Buffer.js';
import WebGLLayerRenderer from 'ol/renderer/webgl/Layer.js';
import { ARRAY_BUFFER, DYNAMIC_DRAW, ELEMENT_ARRAY_BUFFER } from 'ol/webgl.js';
import { AttributeType, DefaultUniform } from 'ol/webgl/Helper.js';
import { create as createTransform } from 'ol/transform.js';
import { createEmpty, equals } from 'ol/extent.js';
import SourceState from 'ol/source/State.js';
// import {noise} from '../test/PerlinNoise.js';
import { fromLonLat } from 'ol/proj';
var NwpImageLayerRenderer = /** @class */ (function (_super) {
    __extends(NwpImageLayerRenderer, _super);
    /**
     * @param {import("../../layer/Layer.js").default} layer Layer.
     * @param {Options} options Options.
    */
    function NwpImageLayerRenderer(layer, options) {
        var _this = this;
        var uniforms = options.uniforms || {};
        var projectionMatrixTransform = createTransform();
        uniforms[DefaultUniform.PROJECTION_MATRIX] = projectionMatrixTransform;
        _this = _super.call(this, layer, {
            uniforms: uniforms,
            postProcesses: options.postProcesses,
        }) || this;
        _this.verticesBuffer_ = new WebGLArrayBuffer(ARRAY_BUFFER, DYNAMIC_DRAW);
        _this.indicesBuffer_ = new WebGLArrayBuffer(ELEMENT_ARRAY_BUFFER, DYNAMIC_DRAW);
        // console.log(` fragment Shader = ${ options.fragmentShader}`);
        _this.program_ = _this.helper.getProgram(options.fragmentShader, options.vertexShader);
        /**
         * A list of attributes used by the renderer. By default only the position and
         * index of the vertex (0 to 3) are required.
         * @type {Array<import('../../webgl/Helper.js').AttributeDescription>}
         */
        _this.attributes = [
            {
                name: 'a_position',
                size: 2,
                type: AttributeType.FLOAT,
            },
            {
                name: 'a_value',
                size: 1,
                type: AttributeType.FLOAT,
            },
            {
                name: 'a_show',
                size: 1,
                type: AttributeType.FLOAT,
            }
        ];
        _this.left_ = layer.getLeft();
        _this.bottom_ = layer.getBottom();
        _this.right_ = layer.getRight();
        _this.top_ = layer.getTop();
        _this.height_ = layer.getHeight();
        _this.width_ = layer.getWidth();
        _this.hasMask_ = layer.getMask() ? true : false;
        _this.mask_ = null;
        _this.stride_ = 0;
        _this.attributes.forEach(function (att) { return _this.stride_ = _this.stride_ + att.size; });
        _this.previousExtent_ = createEmpty();
        /**
         * This transform is updated on every frame and is the composition of:
         * - invert of the world->screen transform that was used when rebuilding buffers (see `this.renderTransform_`)
         * - current world->screen transform
         * @type {import("../../transform.js").Transform}
         * @private
         */
        _this.currentTransform_ = projectionMatrixTransform;
        /**
         * @protected
         * @type {?import("../../ImageBase.js").default}
         */
        _this.first = true;
        _this.source_ = null;
        return _this;
    }
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {HTMLElement} The rendered element.
     */
    NwpImageLayerRenderer.prototype.renderFrame = function (frameState) {
        var renderCount = this.indicesBuffer_.getSize();
        this.helper.drawElements(0, renderCount);
        this.helper.finalizeDraw(frameState);
        var canvas = this.helper.getCanvas();
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        var opacity = layerState.opacity;
        if (opacity !== parseFloat(canvas.style.opacity)) {
            canvas.style.opacity = String(opacity);
        }
        return canvas;
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
    NwpImageLayerRenderer.prototype.prepareFrame = function (frameState) {
        var st = new Date().getTime();
        // console.log(` prepareFrame = ${st}`)
        // console.log(` WindyLayerRenderer -> prepareFrame begin ${new Date().getTime()}`);
        var layer = this.getLayer();
        var viewState = frameState.viewState;
        var source = layer.getSource();
        var viewNotMoving = !frameState.viewHints[ViewHint.ANIMATING] &&
            !frameState.viewHints[ViewHint.INTERACTING];
        var extentChanged = !equals(this.previousExtent_, frameState.extent);
        if (this.hasMask_) {
            if (!this.mask_) {
                this.mask_ = layer.getMask().loadNwpData();
                if (!this.mask_) {
                    return false;
                }
            }
        }
        if (this.source_ != source) {
            if (source.getState() != SourceState.READY) {
                return false;
            }
            else {
                this.source_ = source;
            }
            var data = source.loadNwpData();
            if (data == null) {
                return false;
            }
            this.rebuildBuffers_(frameState, data);
            this.previousExtent_ = frameState.extent.slice();
            // data = null;
            // delete data;
        }
        // apply the current projection transform with the invert of the one used to fill buffers
        this.helper.makeProjectionTransform(frameState, this.currentTransform_);
        this.helper.useProgram(this.program_);
        this.helper.prepareDraw(frameState);
        // write new data
        this.helper.bindBuffer(this.verticesBuffer_);
        this.helper.bindBuffer(this.indicesBuffer_);
        this.helper.enableAttributes(this.attributes);
        // console.log(` prepareFrame end(10) -> ${(new Date().getTime()) - st}`);
        return true;
    };
    /**
    * Rebuild internal webgl buffers based on current view extent; costly, should not be called too much
    * @param {import("../../PluggableMap").FrameState} frameState Frame state.
    * @private
    */
    NwpImageLayerRenderer.prototype.rebuildBuffers_ = function (frameState, data) {
        var viewState = frameState.viewState;
        var resolution = viewState.resolution;
        // saves the projection transform for the current frame state
        var projectionTransform = createTransform();
        this.helper.makeProjectionTransform(frameState, projectionTransform);
        var extents = frameState.extent;
        var size = frameState.size;
        var left = this.left_, top = this.top_, right = this.right_, bottom = this.bottom_;
        var rows = this.height_, cols = this.width_;
        // 행은 끝점 포함, 열은 끝점  미포함
        var rowGap = (top - bottom) / (rows - 1), colGap = (right - left) / cols;
        var positions = [];
        var values = [];
        var shows = [];
        var dataIndex = 0, x = 0, y = 0, vtxCursor = 0, lat = top, lon;
        var vertexBuffer = new ArrayBuffer(this.stride_ * data.length * 4);
        var floatData = new Float32Array(vertexBuffer);
        for (var r = 0; r < rows; r++) {
            lon = left;
            for (var c = 0; c < cols; c++) {
                var point = fromLonLat([lon, lat], "EPSG:3857");
                floatData[vtxCursor] = point[0];
                floatData[vtxCursor + 1] = point[1];
                floatData[vtxCursor + 2] = data[dataIndex];
                if (this.hasMask_) {
                    floatData[vtxCursor + 3] = this.mask_[dataIndex];
                }
                else {
                    floatData[vtxCursor + 3] = 1.0;
                }
                vtxCursor += 4;
                dataIndex++;
                lon += colGap;
            }
            lat -= rowGap;
        }
        // console.log(`top =  ${top}, lat =  ${lat + rowGap}, left = ${left}, lon = ${lon}, dataIndex = ${dataIndex}  `); 
        // console.log(`rows =  ${rows}, cols =  ${cols}, ${ rows * cols}, dataIndex = ${dataIndex}  `); 
        this.makeVertexs(floatData, rows, cols);
    };
    NwpImageLayerRenderer.prototype.makeVertexs = function (floatData, rows, cols) {
        var stt = new Date().getTime();
        var indexData = new Uint32Array((rows - 1) * (cols - 1) * 6);
        var idxCursor = 0;
        for (var r = 0; r < rows - 1; r++) {
            var vtxCursor = r * cols;
            for (var c = 0; c < cols - 1; c++) {
                indexData[idxCursor + 0] = vtxCursor;
                indexData[idxCursor + 1] = vtxCursor + cols;
                indexData[idxCursor + 2] = vtxCursor + 1;
                indexData[idxCursor + 3] = vtxCursor + 1;
                indexData[idxCursor + 4] = vtxCursor + cols;
                indexData[idxCursor + 5] = vtxCursor + cols + 1;
                idxCursor += 6;
                vtxCursor++;
            }
        }
        /*
        console.log(`this.stride_ = ${this.stride_}, vertices =  ${floatData.length}, indices =  ${indexData.length} `);
        console.log(`indices =  ${indexData} `);
        */
        this.verticesBuffer_.fromArrayBuffer(floatData);
        this.helper.flushBufferData(this.verticesBuffer_);
        this.indicesBuffer_.fromArrayBuffer(indexData);
        this.helper.flushBufferData(this.indicesBuffer_);
        /* console.log(` makeVertexs script end(10) ${(new Date().getTime()) - stt}`); */
    };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../../Feature.js").FeatureLike, import("../../layer/Layer.js").default): T} callback Feature callback.
     * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
     * @return {T|void} Callback result.
     * @template T
     */
    NwpImageLayerRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, declutteredFeatures) {
        callback(null);
    };
    /**
     * Clean up.
     */
    NwpImageLayerRenderer.prototype.disposeInternal = function () {
        this.layer_ = null;
        this.image_ = null;
        this.uu_ = null;
        this.vv_ = null;
        _super.prototype.disposeInternal.call(this);
    };
    return NwpImageLayerRenderer;
}(WebGLLayerRenderer));
export default NwpImageLayerRenderer;
//# sourceMappingURL=NwpImageLayerRenderer.js.map